import { Geokoordinatensystem } from './geokoordinatensystem.enum';

export class Geokoordinaten {

    public geokoordinatenSystem?: Geokoordinatensystem;
    public latitude?: number;
    public longitude?: number;

    public hochwert?: number;
    public rechtswert?: number;
    public zone?: number;

    public static createUTM(zone: number, hochwert: number, rechtswert: number) {
        const koordinaten =  new Geokoordinaten();
        koordinaten.zone = zone;
        koordinaten.hochwert = hochwert;
        koordinaten.rechtswert = rechtswert;
        return koordinaten;
    }
}
